var moduleMap = {
	"./routes": () => {
		return Promise.all(/* __federation_expose_routes */[__webpack_require__.e(196), __webpack_require__.e(827), __webpack_require__.e(427), __webpack_require__.e(263), __webpack_require__.e(789), __webpack_require__.e(806)]).then(() => (() => ((__webpack_require__(48941)))));
	},
	"./manifest": () => {
		return __webpack_require__.e(/* __federation_expose_manifest */ 167).then(() => (() => ((__webpack_require__(37293)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});